// Internal
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

// Relative
import GpaSetup from "Administrator/commonComponents/GpaAndCredits/routes/GpaSetup";
import CreditsSetup from "Administrator/commonComponents/GpaAndCredits/routes/CreditsSetup";

export default store => ({
  path: "gpa-and-credits",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "admin-academicSetup-gpaAndCredits" */ "./components"
        ),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [GpaSetup(store), CreditsSetup(store)],
});
